<template>
  <div id="app">
    <router-view />
    <notification-queue />
    <loading-modal />
  </div>
</template>
<script>
import Layout        from './views/dashboard/Layout';
import { NotificationQueue, LoadingModal } from '@/components';
export default {
  components:{
    Layout,
    NotificationQueue,
    LoadingModal,
  },
  mounted(){
    this.$store.dispatch('GET_US_STATES');
  }
};
</script>

<style lang="scss">
@import "./assets/custom_bootstrap";


  #app {
    font-family: $font-family-base;
    font-weight: $font-weight-base;
    height: 100vh;
  }
  body, html {
    color: $ss-grey1;
    background: $gray-100;
  }
</style>
